var _defs, _rect, _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 4.759,
    height: 66.582,
    fill: "#016dd9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_989",
    "data-name": "Rectangle 989",
    width: 4.758,
    height: 66.582,
    fill: "#016dd9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 11.356,
    height: 11.356,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 8.282,
    height: 8.282,
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(-65 -2891)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1168",
    "data-name": "Rectangle 1168",
    width: 102,
    height: 102,
    transform: "translate(65 2891)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fully_customisable",
    "data-name": "Fully customisable",
    transform: "translate(-0.355 3.643)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M96.209,69.657h0a3.916,3.916,0,0,0,3.916-3.916V3.916a3.916,3.916,0,0,0-7.832,0V65.74a3.916,3.916,0,0,0,3.916,3.916",
    transform: "translate(54.987 2903.356)",
    fill: "#c3dbf3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M66.209,69.657h0a3.916,3.916,0,0,0,3.916-3.916V3.916a3.916,3.916,0,0,0-7.832,0V65.74a3.916,3.916,0,0,0,3.916,3.916",
    transform: "translate(61.932 2903.356)",
    fill: "#c3dbf3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M36.209,69.657h0a3.916,3.916,0,0,0,3.916-3.916V3.916a3.916,3.916,0,0,0-7.832,0V65.74a3.916,3.916,0,0,0,3.916,3.916",
    transform: "translate(68.879 2903.356)",
    fill: "#c3dbf3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M6.209,69.657h0a3.916,3.916,0,0,0,3.916-3.916V3.916a3.916,3.916,0,1,0-7.832,0V65.74a3.916,3.916,0,0,0,3.916,3.916",
    transform: "translate(75.825 2903.356)",
    fill: "#c3dbf3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(148.817 2905)",
    opacity: 0.999,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M96.672,68.583A2.382,2.382,0,0,1,94.293,66.2V4.379a2.379,2.379,0,0,1,4.758,0V66.2a2.382,2.382,0,0,1-2.379,2.379",
    transform: "translate(-94.293 -2)",
    fill: "#016dd9"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M101.356,11.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(55.518 2906.064)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768",
    transform: "translate(125.762 2904.894)",
    opacity: 0.999,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M66.672,68.583A2.382,2.382,0,0,1,64.293,66.2V4.379a2.379,2.379,0,0,1,4.758,0V66.2a2.382,2.382,0,0,1-2.379,2.379",
    transform: "translate(-64.293 -2)",
    fill: "#016dd9"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M71.356,71.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(62.463 2888.159)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771",
    transform: "translate(102.709 2904.894)",
    opacity: 0.999,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M36.672,68.583A2.382,2.382,0,0,1,34.293,66.2V4.379a2.379,2.379,0,0,1,4.758,0V66.2a2.382,2.382,0,0,1-2.379,2.379",
    transform: "translate(-34.293 -2)",
    fill: "#016dd9"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M41.356,31.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(69.411 2897.421)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(79.655 2904.894)",
    opacity: 0.999,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M6.672,68.583A2.382,2.382,0,0,1,4.293,66.2V4.379a2.379,2.379,0,1,1,4.758,0V66.2a2.382,2.382,0,0,1-2.379,2.379",
    transform: "translate(-4.293 -2)",
    fill: "#016dd9"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M11.356,61.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(76.356 2890.475)",
    fill: "#407bff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(145.518 2911.699)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M101.356,11.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(-90 -5.635)",
    fill: "#fff"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(147.055 2913.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M96.141,15.917a4.141,4.141,0,1,1,4.141-4.141,4.146,4.146,0,0,1-4.141,4.141",
    transform: "translate(-92 -7.635)",
    fill: "#fafafa"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(122.463 2953.794)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M71.356,71.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(-60 -65.635)",
    fill: "#fff"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(124 2955.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M66.141,75.917a4.141,4.141,0,1,1,4.141-4.141,4.146,4.146,0,0,1-4.141,4.141",
    transform: "translate(-62 -67.635)",
    fill: "#fafafa"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(99.411 2923.056)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M41.356,31.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(-30 -25.635)",
    fill: "#fff"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    transform: "translate(100.948 2924.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M36.141,35.917a4.141,4.141,0,1,1,4.141-4.141,4.146,4.146,0,0,1-4.141,4.141",
    transform: "translate(-32 -27.635)",
    fill: "#fafafa"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(76.356 2946.109)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M11.356,61.313a5.678,5.678,0,1,1-5.678-5.678,5.678,5.678,0,0,1,5.678,5.678",
    transform: "translate(0 -55.635)",
    fill: "#fff"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(77.893 2947.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M6.141,65.917a4.141,4.141,0,1,1,4.141-4.141,4.146,4.146,0,0,1-4.141,4.141",
    transform: "translate(-2 -57.635)",
    fill: "#fafafa"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.a51bacf9777104a6bd586eaa6d2fbae2.svg";
export { ForwardRef as ReactComponent };